// ─────────────────────────────────────────────────────────────────────────────
// NOTION DESIGN TOKENS — the shared look for the Air Duct board's document and
// tool surfaces (Erez, 2026-07-28: "make the design notion style").
//
// What actually makes something read as Notion, in order of importance:
//   1. WARM INK, not black. #37352F. Near-black (#111) reads as a generic app.
//   2. 3px radii. Notion is barely rounded. 14px pills read as a SaaS dashboard.
//   3. HAIRLINE borders and NO shadows. Separation comes from a 1px #E9E9E7
//      line, never from elevation.
//   4. Tinted callouts — a soft background block with an emoji, no left bar.
//   5. Air. Generous line-height, left aligned, minimal chrome.
//
// Colours below are Notion's own palette values, so anything built from these
// sits correctly beside a real Notion page.
// ─────────────────────────────────────────────────────────────────────────────

export const N = {
  // text
  ink: "#37352F",          // primary — warm, never pure black
  ink2: "#787774",         // secondary
  ink3: "#9B9A97",         // tertiary / placeholder
  // surfaces
  bg: "#FFFFFF",
  bgGray: "#F7F6F3",       // Notion's warm page gray
  bgHover: "#EFEFEE",
  bgCode: "#F7F6F3",
  // lines
  line: "#E9E9E7",
  lineSoft: "rgba(55, 53, 47, 0.09)",
  lineStrong: "rgba(55, 53, 47, 0.16)",
  // accents — {ink, bg} pairs, straight from Notion's colour menu
  red: "#E03E3E", redBg: "#FBECEB",
  orange: "#D9730D", orangeBg: "#FAEBDD",
  yellow: "#CB912F", yellowBg: "#FBF3DB",
  green: "#0F7B6C", greenBg: "#EDF3EC",
  blue: "#0B6E99", blueBg: "#E7F3F8",
  purple: "#6940A5", purpleBg: "#F6F3F9",
  gray: "#787774", grayBg: "#F1F1EF",
} as const;

/** Notion's actual UI stack. */
export const NFONT =
  'ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif';

export const NMONO =
  '"SFMono-Regular", Menlo, Consolas, "PT Mono", "Liberation Mono", Courier, monospace';

/** Notion rounds almost nothing. 3px on blocks, 4px on inputs and buttons. */
export const R = 3;
export const R_CTL = 4;
